<template>
  <div>
    <!-- Individual Donation -->
    <div class="donate-layout">
      <div class="earth-hour-header">
        <h2>{{ title }}</h2>
        <h4>{{ text }}</h4>
      </div>

      <div
        class="sign-img"
        :style="{
          'background-image': 'url(\'' + imageUrl + '\')',
        }"
      ></div>
      <div class="subtitle">
        <button type="button" v-on:click="donate()">{{ buttonLabel }}</button>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "EarthhourPopup",
  data: function () {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      postCode: "",
    };
  },

  props: {
    mediaPackUrl: {
      type: String,
      default: "/documents/social-assets",
    },
    individualTitle: {
      type: String,
      default: "Want to do even more this Earth Hour?",
    },
    individualText: {
      type: String,
      default:
        "Donate to WWF's Regenerate Australia campaign to support the plan to make Australia a Renewable Energy Exports Powerhouse.",
    },
    individualImageUrl: {
      type: String,
      default:
        "https://www.earthhour.org.au/images/UserUploadedImages/624/Solar-installation.jpg",
    },
    individualButtonLabel: {
      type: String,
      default: "Donate Now",
    },
    individualButtonLink: {
      type: String,
      default:
        "https://donate.wwf.org.au/donate/one-off-donation/renewables-nation",
    },
    businessTitle: {
      type: String,
      default: "Want to do even more this Earth Hour?",
    },
    businessText: {
      type: String,
      default:
        "Donate to WWF's Regenerate Australia campaign to support the plan to make Australia a Renewable Energy Exports Powerhouse.",
    },
    businessImageUrl: {
      type: String,
      default:
        "https://www.earthhour.org.au/images/UserUploadedImages/624/Solar-installation.jpg",
    },
    businessButtonLabel: {
      type: String,
      default: "Donate Now",
    },
    businessButtonLink: {
      type: String,
      default:
        "https://donate.wwf.org.au/donate/one-off-donation/renewables-nation",
    },
    schoolTitle: {
      type: String,
      default: "Want to do even more this Earth Hour?",
    },
    schoolText: {
      type: String,
      default:
        "Donate to WWF's Regenerate Australia campaign to support the plan to make Australia a Renewable Energy Exports Powerhouse.",
    },
    schoolImageUrl: {
      type: String,
      default:
        "https://www.earthhour.org.au/images/UserUploadedImages/624/Solar-installation.jpg",
    },
    schoolButtonLabel: {
      type: String,
      default: "Donate Now",
    },
    schoolButtonLink: {
      type: String,
      default:
        "https://donate.wwf.org.au/donate/one-off-donation/renewables-nation",
    },
    communityTitle: {
      type: String,
      default: "Want to do even more this Earth Hour?",
    },
    communityText: {
      type: String,
      default:
        "Donate to WWF's Regenerate Australia campaign to support the plan to make Australia a Renewable Energy Exports Powerhouse.",
    },
    communityImageUrl: {
      type: String,
      default:
        "https://www.earthhour.org.au/images/UserUploadedImages/624/Solar-installation.jpg",
    },
    communityButtonLabel: {
      type: String,
      default: "Donate Now",
    },
    communityButtonLink: {
      type: String,
      default:
        "https://donate.wwf.org.au/donate/one-off-donation/renewables-nation",
    },
  },
  computed: {
    ...mapState({
      product: (state) => state.product.product,
      lead: (state) => state.earthHour,
      leadFirstName: (state) => state.earthHour.firstName,
      leadLastName: (state) => state.earthHour.lastName,
      leadEmail: (state) => state.earthHour.email,
      leadPhone: (state) => state.earthHour.phone,
      leadPostCode: (state) => state.earthHour.postCode,
      leadIAmA: (state) => state.earthHour.iAmA,
    }),
    title() {
      return this[`${this.leadIAmA}Title`];
    },
    text() {
      return this[`${this.leadIAmA}Text`];
    },
    buttonLabel() {
      return this[`${this.leadIAmA}ButtonLabel`];
    },
    imageUrl() {
      return this[`${this.leadIAmA}ImageUrl`];
    },
    buttonLink() {
      return this[`${this.leadIAmA}ButtonLink`];
    },
  },

  watch: {
    leadFirstName(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.firstName = newVal;
      }
    },
    leadLastName(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.lastName = newVal;
      }
    },
    leadEmail(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.email = newVal;
      }
    },
    leadPhone(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.phone = newVal;
      }
    },
    leadPostCode(newVal, oldVal) {
      if (newVal && newVal.length > 0) {
        this.postCode = newVal;
      }
    },
  },

  mounted() {
    console.log("mounted popup");
    $("button.close-button").click({ callback: this.logCloseButton }, function (e) {
      e.preventDefault();
      try {
        e.data.callback();
      } catch (err) {
        console.error(err);
      }
    });
  },

  methods: {
    donate() {
      let query = `firstname=${this.firstName}`;
      query += `&lastname=${this.lastName}`;
      query += `&email=${this.email}`;
      query += `&source=${document.URL}`;

      let params = "?q=" + window.btoa(query);

      try {
        const gaTag = ga.getAll()[0].get("linkerParam");
        if (gaTag) {
          params += `&${gaTag}`;
        }
      } catch (err) {
        console.error(err);
      }

      const url = this.buttonLink + params;

      // Log Amplitude
      this.$store.dispatch("logEarthHourPopup", {
        name: "pop-up cta clicked",
        url: url,
      });

      window.open(url, "_self");
    },
    logCloseButton() {
      this.$store.dispatch("logEarthHourPopup", {
        name: "pop-up declined",
      });
    },
  },
};
</script>

<style scoped>
.intro,
.outro {
  width: 100%;
  margin: 14px 0;
  padding: 0 6px;
  text-align: center;
  color: var(--wwfWhite);
}

.intro p {
  margin: 6px 0;
  font-size: 20px;
}

.intro a,
.outro a {
  font-size: 18px;
}

.intro a:hover,
.outro a:hover {
  color: var(--wwfWhite);
}

.subtitle {
  width: 100%;
  margin: 16px 0;
  text-align: center;
  font-size: 24px;
  color: var(--wwfWhite);
}

.subtitle button {
  margin: 16px;
  padding: 16px 24px;
  background-color: var(--wwfBlue);
  color: var(--wwfWhite);
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
}

@media only screen and (max-width: 1050px) {
  .cta {
    width: 100%;
    flex-basis: 100%;
  }
}

.sign-img {
  height: 250px;
  margin: 12px 16px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
</style>


// WEBPACK FOOTER //
// EarthhourPopup.vue?1791fa81